// This icon file is generated automatically.
var PReloadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.2 2.27l-.88.69A6.55 6.55 0 00.6 6.99a6.56 6.56 0 0012.73 2.26.13.13 0 00-.08-.16l-.88-.3a.12.12 0 00-.16.07l-.1.23a5.35 5.35 0 01-4.94 3.29A5.33 5.33 0 012.2 9.09a5.35 5.35 0 011.15-5.9 5.39 5.39 0 018.03.5l-.94.73c-.08.07-.05.2.05.22l2.74.67c.08.02.16-.04.16-.12V2.37c0-.1-.11-.16-.2-.1z", "fill-rule": "nonzero" } }] }, "name": "p-reload", "theme": "outlined" };
export default PReloadOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PReloadOutlined.js
// module id = 3593
// module chunks = 0